// This file should not include any other big imports that redo/shopify/extension/src/index.ts does not already have. It should be very minimal and only include code that runs before the marketing embedded form is initialized.
import { WidgetAutocheck } from "@redotech/redo-model/widget";

export const isMarketingEmbeddedFormEnabled = ({
  autocheck,
}: {
  autocheck: WidgetAutocheck;
}): boolean => {
  return !!(
    autocheck.marketing?.enabled &&
    (autocheck.marketing?.numEmbeddedFormsConfigured === undefined || // TODO: Remove after 11/7/25. For backwards compatibility only, if this is undefined, we assume it is enabled.
      autocheck.marketing?.numEmbeddedFormsConfigured > 0)
  );
};
